var render = function render(){var _vm=this,_c=_vm._self._c;return _c('task-list',{attrs:{"resource":_vm.resource,"archivedResource":_vm.archivedResource,"root":_vm.root,"taskStage":_vm.taskStage,"listId":_vm.id,"objId":_vm.objId,"getParams":_vm.getParams,"ignoreResId":_vm.ignoreResId}})
}
var staticRenderFns = []

export { render, staticRenderFns }